// extracted by mini-css-extract-plugin
module.exports = {"root":"ScoreBadge_root__dYYIa","total":"ScoreBadge_total__U0ssJ","sufficient":"ScoreBadge_sufficient__2A2Nb","insufficient":"ScoreBadge_insufficient__1cDF-"};